"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIDI_DEVICES_LIMIT = void 0;
exports.MIDI_DEVICES_LIMIT = {
    lite: 0,
    plus_v2: 0,
    /** @deprecated */ pro: 0,
    pro_v2: 2,
    /** @deprecated */ premium: 0,
    premium_v2: 4,
    /** @deprecated */ ultimate: Infinity,
    ultimate_v2: Infinity,
};
//# sourceMappingURL=midi.js.map